<template>
  <div class="offer-confirm spacey-24">
    <div class="spacey-8">
      <div class="offer-confirm__title">
        {{ context.isDelete ? $t('Delete offer?') : $t('Archive offer?') }}
      </div>
      <div class="offer-confirm__text">
        {{ alertText }}
      </div>
    </div>
    <div class="offer-confirm__actions spacex-8">
      <Button
        size="small"
        color="danger"
        @click="deleteIncomingTenderVersion(context.tenderVersionId)"
      >
        {{ context.isDelete ? $t('Delete') : $t('Archive') }}
      </Button>
      <Button size="small" color="neutral" @click="closeModal">
        {{ $t('Return') }}
      </Button>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import { mapActions, mapState } from 'vuex';
  import get from 'lodash.get';
  import router from '@/router';

  export default {
    name: 'DeleteOfferConfirm',
    components: {
      Button,
    },
    props: {
      context: {
        type: Object,
        default: () => ({
          tenderVersionId: Number,
          isDelete: Boolean,
        }),
      },
    },
    computed: {
      ...mapState('incomingTender', ['incomingTenderInfo']),
      alertText() {
        const commonText = this.context.isDelete
          ? this.$t('This action cannot be undone.')
          : this.$t('You can unarchive it later.');
        const listId = get(router, 'currentRoute.params.incomingTenderListId');
        if (listId) {
          const currentEstimate = this.incomingTenderInfo?.lists?.find(
            (list) => +list.id === +listId
          );
          if (currentEstimate?.title) {
            return `${commonText} ${this.$t('Not just')} "${currentEstimate.title}"`;
          }
        }
        return commonText;
      },
    },
    methods: {
      ...mapActions({
        deleteVersion: 'incomingTender/deleteIncomingTenderVersion',
        closeModal: 'modal/closeModal',
      }),
      async deleteIncomingTenderVersion(tenderVersionId) {
        await this.deleteVersion(tenderVersionId);
        this.closeModal();
      },
    },
  };
</script>
